import script from "./AdminMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMenu.vue?vue&type=script&setup=true&lang=js"

import "./AdminMenu.vue?vue&type=style&index=0&id=a1346d0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1346d0c"]])

export default __exports__